import React from "react";
import { View, StyleSheet } from "react-native";
import { SparkleIcon } from "@phosphor-icons/react";
import CustomText from "../../../common/general/CustomText/CustomText";
import CustomButton from "../../../common/general/CustomButton/CustomButton";
import {
  colors,
  semanticColors,
  spacing,
  radii,
  typographyScale,
  shadowStyles,
} from "../../../../styles/design-system";

export interface VisualizationCardProps {
  visualizationId: string;
  visualizationType: string;
  visualizationDescription?: string | null;
  onPress: () => void;
}

export const VisualizationCard = ({
  visualizationId,
  visualizationType,
  visualizationDescription,
  onPress,
}: VisualizationCardProps) => {
  return (
    <View style={styles.container} testID={`visualization-card-${visualizationId}`}>
      <View style={styles.row}>
        <View style={styles.iconBox}>
          <SparkleIcon size={18} color={colors.blue[600]} />
        </View>
        <View style={styles.textArea}>
          <CustomText
            style={styles.titleText}
            text={
              visualizationType === "interactive"
                ? "Interactive Visualization"
                : visualizationType === "nonInteractive"
                  ? "Animated Visualization"
                  : "Visualization"
            }
            useTranslationText={false}
            weight="bold"
          />
          {visualizationDescription ? (
            <CustomText
              style={styles.descriptionText}
              text={visualizationDescription}
              useTranslationText={false}
              numberOfLines={2}
              ellipsizeMode="tail"
            />
          ) : null}
          <CustomButton
            style={styles.button}
            styleType={"dark"}
            onPress={onPress}
            text="Open Activity"
            useTranslationText={false}
            leftIcon={null}
            rightIcon={null}
            accessibilityLabel="Open visualization activity"
            accessibilityRole="button"
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: semanticColors.surface.white,
    borderRadius: radii.xl,
    borderWidth: 1,
    borderColor: colors.grey[200],
    marginBottom: spacing.sm,
    padding: spacing.md,
    ...shadowStyles.sm,
  },
  row: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: spacing.sm,
  },
  iconBox: {
    width: 40,
    height: 40,
    backgroundColor: colors.blue[50],
    borderRadius: radii.full,
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },
  textArea: {
    flex: 1,
    gap: spacing.xs,
  },
  titleText: {
    fontSize: typographyScale.textBase.fontSize,
    color: semanticColors.typography.displayPrimary,
  },
  descriptionText: {
    fontSize: typographyScale.textSm.fontSize,
    color: semanticColors.typography.textSecondary,
    lineHeight: typographyScale.textSm.lineHeight,
  },
  button: {
    alignSelf: "flex-start",
    backgroundColor: colors.blue[600],
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.xs,
    borderRadius: radii.md,
    marginTop: spacing.xxs,
  },
});
